import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "program-table" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "program-name" }
const _hoisted_4 = { class: "available-delivery-type" }
const _hoisted_5 = { colspan: "100%" }
const _hoisted_6 = { class: "college-info" }
const _hoisted_7 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 1,
  class: "mb-1"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["href"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 2,
  class: "details"
}
const _hoisted_16 = {
  key: 0,
  class: "details-label"
}
const _hoisted_17 = ["href", "target", "rel"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 0,
  class: "no-results"
}

import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useProgramStore } from '@ProgramList/stores/programStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProgramTable',
  setup(__props) {

const route = useRoute();
const store = useProgramStore();
const { filteredPrograms } = storeToRefs(store);

function isExternal(url: string): boolean {
  return !url.startsWith('/') && !url.includes(window.location.hostname);
}

// update results based on query params
onMounted(async () => {
    await store.loadProgramsFromDom();
    store.initFromRoute(route);
});

// static table column headings
const typeColumns = [
	'bachelor',
	'minor',
	'master',
	'doctorate',
	'certificate',
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" Program Results "),
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            class: "program-heading",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(store).toggleSortOrder && _unref(store).toggleSortOrder(...args)))
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "fa-solid fa-sort" }, null, -1 /* CACHED */),
            _createTextVNode("Program")
          ])),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(typeColumns, (col) => {
            return _createElementVNode("th", {
              key: col,
              class: "not-first-col"
            }, _toDisplayString(col), 1 /* TEXT */)
          }), 64 /* STABLE_FRAGMENT */)),
          _cache[2] || (_cache[2] = _createElementVNode("th", null, "Delivery", -1 /* CACHED */))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredPrograms), (program, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: program.name
          }, [
            _createCommentVNode(" Main row with dynamic class "),
            _createElementVNode("tr", {
              onClick: ($event: any) => (program.expanded = !program.expanded),
              class: _normalizeClass([ index % 2 === 0 ? 'bg-white' : 'bg-light', 'main-row', { expanded: program.expanded } ])
            }, [
              _createElementVNode("td", _hoisted_3, [
                _createElementVNode("button", null, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fa-regular fa-angle-down", { 'rotated': program.expanded }])
                  }, null, 2 /* CLASS */),
                  _createTextVNode(" " + _toDisplayString(program.name), 1 /* TEXT */)
                ])
              ]),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(typeColumns, (type) => {
                return _createElementVNode("td", {
                  key: type,
                  class: "available-program-type-indicator not-first-col"
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["type-indicator", { filled: program.types[type], empty: !program.types[type] }])
                  }, null, 2 /* CLASS */)
                ])
              }), 64 /* STABLE_FRAGMENT */)),
              _createElementVNode("td", _hoisted_4, [
                _createElementVNode("span", {
                  class: _normalizeClass({ 'is-faded': !program.delivery.online })
                }, _cache[3] || (_cache[3] = [
                  _createElementVNode("i", { class: "fa-regular fa-desktop" }, null, -1 /* CACHED */)
                ]), 2 /* CLASS */),
                _createElementVNode("span", {
                  class: _normalizeClass({ 'is-faded': !program.delivery.on_campus })
                }, _cache[4] || (_cache[4] = [
                  _createElementVNode("i", { class: "fa-regular fa-landmark" }, null, -1 /* CACHED */)
                ]), 2 /* CLASS */)
              ])
            ], 10 /* CLASS, PROPS */, _hoisted_2),
            _createCommentVNode(" Expanded detail row with matching background "),
            (program.expanded)
              ? (_openBlock(), _createElementBlock("tr", {
                  key: 0,
                  class: _normalizeClass([{'bg-white': index % 2 === 0, 'bg-light': index % 2 !== 0}, "expanded-row"])
                }, [
                  _createElementVNode("td", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createCommentVNode(" College/Dept. "),
                      (program.college)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _cache[5] || (_cache[5] = _createTextVNode(" College: ")),
                            (program.college.url)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                  _createElementVNode("a", {
                                    href: program.college.url,
                                    class: "link"
                                  }, _toDisplayString(program.college.name), 9 /* TEXT, PROPS */, _hoisted_9)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(program.college.name), 1 /* TEXT */))
                          ]))
                        : _createCommentVNode("v-if", true),
                      (program.department)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _cache[6] || (_cache[6] = _createTextVNode(" Department: ")),
                            (program.department.url)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                  _createElementVNode("a", {
                                    href: program.department.url,
                                    class: "link"
                                  }, _toDisplayString(program.department.name), 9 /* TEXT, PROPS */, _hoisted_13)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(program.department.name), 1 /* TEXT */))
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" Details "),
                      (program.customDetails || program.details)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            (program.details)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, "View Details for:"))
                              : _createCommentVNode("v-if", true),
                            _createCommentVNode(" Show details "),
                            (program.details)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(program.details, (detail, type) => {
                                  return (_openBlock(), _createElementBlock("span", { key: type }, [
                                    _createElementVNode("a", {
                                      href: detail.url,
                                      class: "link link--styled link--arrow",
                                      target: isExternal(detail.url) ? '_blank' : null,
                                      rel: isExternal(detail.url) ? 'noopener noreferrer' : null
                                    }, _toDisplayString(detail.label), 9 /* TEXT, PROPS */, _hoisted_17)
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              : _createCommentVNode("v-if", true),
                            _createCommentVNode(" Show customDetails (WYSIWYG data for custom links) if available "),
                            (program.customDetails)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  innerHTML: program.customDetails,
                                  class: "custom-links"
                                }, null, 8 /* PROPS */, _hoisted_18))
                              : _createCommentVNode("v-if", true)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        }), 128 /* KEYED_FRAGMENT */)),
        (_unref(filteredPrograms).length === 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_19, _cache[7] || (_cache[7] = [
              _createElementVNode("td", {
                colspan: "100%",
                class: "text-center"
              }, " Sorry, no exact matches were found, please adjust your search criteria. ", -1 /* CACHED */)
            ])))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}
}

})